(() => {
  if (window.__paintFuFormatSwitchAnalyticsBound) return;
  window.__paintFuFormatSwitchAnalyticsBound = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-pf-format-switch-link]');
    if (!link) return;

    const parameters = {
      source_format: link.dataset.sourceFormat,
      destination_format: link.dataset.destinationFormat,
      source_product_id: link.dataset.sourceProductId,
      destination_product_id: link.dataset.destinationProductId,
      source_product_handle: link.dataset.sourceProductHandle,
      destination_product_handle: link.dataset.destinationProductHandle,
      link_position: link.dataset.linkPosition,
      transport_type: 'beacon'
    };

    if (new URLSearchParams(window.location.search).has('pf_format_analytics_debug')) {
      parameters.debug_mode = true;
    }

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };
    window.gtag('event', 'format_switch_click', parameters);
  });
})();
